module.exports = __webpack_public_path__ + "static/media/twitterIcon.078649f9.svg";